var _path, _path2, _path3, _line, _path4, _line2, _path5, _line3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _rect, _rect2, _circle21, _path6, _path7, _circle22, _path8, _path9, _path10, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _path11, _path12, _circle40, _path13, _path14, _path15, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourLongMiddleBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 10 L 200 10 L 200 190 L 0 190",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 70 70 L 35 72 L 35 128 L 70 130 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 80 L 45 80 L 45 90 L 35 90",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 85,
    x2: 0,
    y2: 85,
    stroke: "black",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 95 L 45 95 L 45 105 L 35 105",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 100,
    x2: 0,
    y2: 100,
    stroke: "black",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 110 L 45 110 L 45 120 L 35 120",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 115,
    x2: 0,
    y2: 115,
    stroke: "black",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 145,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 55,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 145,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 55,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 165,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 35,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 165,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 35,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 175,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 25,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 175,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 25,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 180,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 20,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 180,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 20,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 181,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 19,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 181,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 19,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 135,
    width: 20,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 55,
    width: 20,
    height: 10
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    r: 15,
    cx: 27,
    cy: 33,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 37 23 L 37 33 L 17 33 L 17 23 ",
    strokeWidth: 3,
    fill: "transparent",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 27 28 L 27 8",
    strokeWidth: 3,
    stroke: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    r: 15,
    cx: 27,
    cy: 167,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 37 177 L 37 167 L 17 167 L 17 177 ",
    strokeWidth: 3,
    fill: "transparent",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 27 172 L 27 192",
    strokeWidth: 3,
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 60 L 115 30 L 165 30 L 195 60 L 195 140 L 165 170 L 115 170 L 80 140 Z",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 143,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 57,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 143,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 57,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 130,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 70,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 130,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 70,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 140,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 60,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 140,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 155,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 45,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 155,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 45,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    r: 15,
    cx: 138,
    cy: 49,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 148 39 L 148 49 L 128 49 L 128 39 ",
    strokeWidth: 3,
    fill: "transparent",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 138 44 L 138 24",
    strokeWidth: 3,
    stroke: "black"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    r: 15,
    cx: 138,
    cy: 151,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 148 161 L 148 151 L 128 151 L 128 161 ",
    strokeWidth: 3,
    fill: "transparent",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 138 156 L 138 176",
    strokeWidth: 3,
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 85 85 L 105 68 L 175 68 L 190 85 L 190 115 L 175 132 L 105 132 L 85 115 Z",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 2
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 110,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 90,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 120,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 80,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 120,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 80,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 120,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 124,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 76,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 124,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 76,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 100,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 90,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 110,
    r: 5,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152,
    cy: 100,
    rx: 35,
    ry: 17,
    fill: "#aaa",
    stroke: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 100,
    rx: 30,
    ry: 12,
    fill: "#black"
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourLongMiddleBack);
export default __webpack_public_path__ + "static/media/FourLongMiddleBack.c4ccfb1c9a4833e9fe59c57e0b88d7b7.svg";
export { ForwardRef as ReactComponent };